import * as React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

function BootstrapDialogTitle(props: DialogTitleProps) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

export default function PaybackTimeModal() {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = (e) => {
    e.preventDefault();
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      A payback time of 10 years or less is a good deal for a public company.<a href="" onClick={handleClickOpen}> Learn More</a>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
          Payback Time
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom>
            Payback time is the number of years it will take us to recoup our investment capital from the free cash flow generated by a business at an estimated growth rate if we bought the entire company at today's market cap.
          </Typography>
          <Typography gutterBottom>
            <p>The payback time is calculated using the following:</p>
            <p>
              <strong>1. Growth Rate:</strong> This is the estimated growth rate of the business for the next ten years. It is the same growth rate number we use for calculating the margin of safety.
            </p>
            <p>
              <strong>2. Free Cash Flow (FCF):</strong> This is the business's Free Cash Flow (TTM). If the FCF TTM is unavailable, we can use the latest reported Annual Free Cash Flow.
            </p>
            <p>
              <strong>3. Market value:</strong> This is the business's market capitalization or market Cap.
            </p>
          </Typography>
          <Typography>
            <h3>How to calculate Payback time</h3>
            <p>
              To calculate the payback time, we grow the free cash flow by the growth rate per year until it reaches the market cap of the business.
            </p>
          </Typography>
          <Typography>
            <p>
              <h3>What is a reasonable payback time?</h3>
              A payback time of 10 years or less is great for a public company. The lower the payback time, the better.
              A payback time of 8 years or less is very good value. 5 years is an extreme bargain, especially if it's a profitable and predictable business.
            </p>
          </Typography>
          <Typography>
            <p>
              <h3>Results of the Payback Time Calculation</h3>
              <strong>5 years payback time price:</strong> This is the price you would pay for the stock to get a payback time of 5 years <br/>
              <strong>8 years payback time price:</strong> This is the price you would pay for the stock to get a payback time of 8 years <br/>
              <strong>10 years payback time price:</strong> This is the price you would pay for the stock to get a payback time of 10 years <br/>
              <strong>MOS Payback Time:</strong> This is the payback time if you bought the stock at the calculated Margin of safety price. <br/>
              <strong>Current payback time:</strong> This is the payback time if you buy the stock at today's market price. <br/>
            </p>
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose}>
            Close
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
}
